import React from 'react';
import { Link } from 'react-router-dom';
import { IoChevronUp } from 'react-icons/io5';
import logo from '../assests/img/logo.png';

const footerColumns = [
  {
    title: 'Exhibition',
    links: [
      { label: 'Exhibitor Profile' },
      { label: 'Space Booking Form' },
      { label: 'Floor Plan' },
      { label: 'List of Participants' },
    ],
  },
  {
    title: 'Visitor',
    links: [
      { label: 'Visitor Profile' },
      { label: 'Visitor Registration' },
    ],
  },
  {
    title: 'Company',
    links: [
      { label: 'About Company' },
      { label: 'Our Mission' },
      { label: 'Careers & Reviews' },
      { label: 'Contact Us', to: '/contact' },
    ],
  },
  {
    title: 'Quick Link',
    links: [
      { label: 'Home', to: '/home' },
      { label: 'Media' },
      { label: 'Sitemap' },
      { label: 'Terms & Conditions' },
      { label: 'Privacy Policy' },
    ],
  },
];

function Footer() {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="ma-footer">
      <div className="ma-container">
        <div className="ma-footer-top">
          <Link to="/home" className="ma-footer-logo-link" aria-label="MobileAcc Expo Home">
            <img className="ma-footer-logo" src={logo} alt="MobileAcc Expo" />
          </Link>
        </div>

        <div className="ma-footer-grid">
          {footerColumns.map((column) => (
            <div key={column.title} className="ma-footer-column">
              <h3>{column.title}</h3>
              <ul>
                {column.links.map((link) => (
                  <li key={link.label}>
                    {link.to ? (
                      <Link to={link.to}>{link.label}</Link>
                    ) : (
                      <span className="ma-footer-link-static">{link.label}</span>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>

      <div className="ma-footer-bottom">
        <div className="ma-container ma-footer-bottom-inner">
          <p>Copyright &copy; 2026 MobileAcc Expo. All Rights Reserved.</p>
          <button
            type="button"
            className="ma-back-to-top"
            onClick={scrollToTop}
            aria-label="Back to top"
          >
            <IoChevronUp />
          </button>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
